<template lang="pug">
v-form#purchaseForm(
  ref="purchaseForm",
  @submit.prevent="doSave",
  lazy-validation
)
  v-container(grid-list-md)
    v-layout(row)
      v-flex(lg2, md2, xs12)
        v-text-field(
          dense,
          v-model="list.customerId",
          v-numeric-only,
          label="No. Handphone",
          required,
          :rules="[(v) => !!v || 'Masukan no handphone']"
        )
      v-flex(lg5, md5, xs12)
        v-text-field(
          dense,
          v-model="list.description",
          label="Keterangan",
          required,
          :rules="[(v) => !!v || 'Masukan keterangan']"
        )
    .ma-2.menu-btn(justify-center, style="text-align: center")
      v-btn.mx-1(@click="doCancel") Kembali
        v-icon mdi-arrow-left
      v-btn.mx-1(
        color="btnprimary white--text",
        type="submit",
        form="purchaseForm"
      ) Simpan
        v-icon mdi-content-save-outline
</template>
<script>
export default {
  name: "FPurchaseListForm",
  props: ["productId", "productGroup"],
  data() {
    return {
      list: {
        customerId: "",
        description: "",
      },
    };
  },
  mounted() {
    this.doReset();
  },
  methods: {
    doReset() {
      if (this.$refs.purchaseForm) {
        this.$refs.purchaseForm.resetValidation();
      }
      this.list = {
        customerId: "",
        description: "",
      };
    },
    doSave() {
      if (this.$refs.purchaseForm.validate()) {
        this.doInquiryPrefix();
      }
    },
    doCancel() {
      this.$emit("cancel");
      this.doReset();
    },
    doInquiryPrefix() {
      if (this.productId) {
        this.prefix = null;
        this.$http
          .get(
            "/api/parameter/prefix/" +
              this.productId +
              "/" +
              this.list.customerId.substring(0, 4)
          )
          .then(
            (success) => {
              this.$emit("list", this.list);
              this.doReset();
            },
            (err) => {
              this.$message.error(
                "Prefix tidak terdaftar untuk jenis transaksi yang anda pilih"
              );
            }
          );
      }
    },
  },
};
</script>